import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from "axios";
import VueElementLoading from 'vue-element-loading'
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'

Vue.component('VueElementLoading', VueElementLoading)
Vue.component('datetime', Datetime);
Vue.use(Datetime)

//Production Ip
// Vue.prototype.baseURL = 'http://13.126.53.44/document/get/' 
// axios.defaults.baseURL = 'http://13.126.53.44' 
Vue.prototype.baseURL = 'https://alsadeel.ml/document/get/' 
axios.defaults.baseURL = 'https://alsadeel.ml' 
Vue.prototype.mainURL = 'https://alsadeel.ml/' 

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
